import { render, staticRenderFns } from "./Apoios.vue?vue&type=template&id=5de47beb"
import script from "./Apoios.vue?vue&type=script&lang=js"
export * from "./Apoios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports